import { GenericMessage } from "../../lib/messages";
export class ResultsMessage extends GenericMessage {
}
